/**
 * GENERATED_ASSET — exact snapshot of the canonical render tokens (`hush-palette-style.1`) the batch005 art was
 * reviewed against (`domestic-window/recipes/render-tokens.json`, identical to the docs catalog copy). Deep-frozen.
 * The hushDomestic test pins parity with `docs/plans/2026-10-20-hush-nook-lanternskip/catalog/render-tokens.json`.
 */
import type { Tokens } from './types';
import { deepFreeze } from './freeze';

export const HUSH_DOMESTIC_TOKENS: Readonly<Tokens> = deepFreeze({
  "revision": "hush-palette-style.1",
  "palettes": {
    "coastal_salt": {
      "outline": "#2B4145",
      "outlineSoft": "#586D69",
      "paperBase": "#D7BC83",
      "paperLight": "#F0DEB0",
      "paperShadow": "#A88A54",
      "warmCore": "#FFE3A0",
      "woodBase": "#826B4D",
      "woodLight": "#A18A61",
      "woodShadow": "#594C3B",
      "clothBlue": "#6C9BAE",
      "clothBlueLight": "#AAC8CE",
      "clothBlueShadow": "#426C7D",
      "reedBase": "#84956C",
      "reedLight": "#AFB68A",
      "reedShadow": "#5D7459",
      "stoneBase": "#8C9C96",
      "stoneLight": "#B5BDA7",
      "stoneShadow": "#627873",
      "moss": "#78966B",
      "salt": "#D1D6BF",
      "waterFar": "#527E86",
      "waterLight": "#A9C7C4"
    },
    "nook_warm": {
      "outline": "#2B4145",
      "outlineSoft": "#586D69",
      "paperBase": "#E5C991",
      "paperLight": "#F5E4BF",
      "paperShadow": "#A88A54",
      "warmCore": "#FFE8AB",
      "woodBase": "#927754",
      "woodLight": "#A18A61",
      "woodShadow": "#594C3B",
      "clothBlue": "#6C9BAE",
      "clothBlueLight": "#AAC8CE",
      "clothBlueShadow": "#426C7D",
      "reedBase": "#8D9B73",
      "reedLight": "#AFB68A",
      "reedShadow": "#5D7459",
      "stoneBase": "#949F8B",
      "stoneLight": "#B5BDA7",
      "stoneShadow": "#687C6B",
      "moss": "#78966B",
      "salt": "#D1D6BF",
      "waterFar": "#527E86",
      "waterLight": "#A9C7C4"
    },
    "icon_ink": {
      "outline": "#253A42",
      "outlineSoft": "#586D69",
      "paperBase": "#DBBF7F",
      "paperLight": "#F9E5B5",
      "paperShadow": "#A88A54",
      "warmCore": "#FFE9A6",
      "woodBase": "#826B4D",
      "woodLight": "#A18A61",
      "woodShadow": "#594C3B",
      "clothBlue": "#6C9BAE",
      "clothBlueLight": "#AAC8CE",
      "clothBlueShadow": "#426C7D",
      "reedBase": "#84956C",
      "reedLight": "#AFB68A",
      "reedShadow": "#5D7459",
      "stoneBase": "#85AAA5",
      "stoneLight": "#BED4C1",
      "stoneShadow": "#627873",
      "moss": "#78966B",
      "salt": "#D1D6BF",
      "waterFar": "#527E86",
      "waterLight": "#A9C7C4"
    }
  },
  "style": {
    "outerStroke": 2.1,
    "seamStroke": 1.2,
    "grainStroke": 0.65,
    "grainOpacity": 0.14,
    "contactShadowOpacity": 0.18,
    "coordinatePrecision": 3,
    "samplingPadding": 2
  },
  "detailTiers": {
    "readable": {
      "grainMarks": 0,
      "minorRepairs": false
    },
    "standard": {
      "grainMarks": 8,
      "minorRepairs": true
    },
    "close": {
      "grainMarks": 14,
      "minorRepairs": true
    }
  },
  "masterMotif": {
    "id": "hush.two_over_one.v1",
    "centers": [
      {
        "x": -12,
        "y": -56
      },
      {
        "x": 12,
        "y": -56
      },
      {
        "x": 0,
        "y": -32
      }
    ],
    "radius": 7.5,
    "protectedRadius": 10,
    "randomization": "forbidden"
  }
});
